import ox from '$/ox'
import _ from '$/underscore'
import $ from '$/jquery'

const config = ox.serverConfig && ox.serverConfig.loginPage
const l10n = _.extend({
  de_DE: 'E-Mail',
  en_US: 'Email',
  en_GB: 'Email',
  es_ES: 'Correo electrónico',
  es_MX: 'Correo electrónico',
  fr_CA: 'Courrier électronique',
  fr_FR: 'Courriel',
  it_IT: 'Indirizzo di posta'
}, (config && config.emailLabel) || {})

$('label[for="io-ox-login-username"]')
  .attr('data-i18n', 'Email')
  .data('translations', l10n)
  .text(l10n[ox.language] || l10n.en_US)
$('#io-ox-login-username')
  .attr('data-i18n', 'Email')
  .data('translations', l10n)
